import ZAVA_DE from './zava.de'
import ZAVA_UK from './zava.uk'
import ZAVA_FR from './zava.fr'
import ZAVA_IE from './zava.ie'
import ZAVA_ES from './zava.es'
import ZAVA_IT from './zava.it'
import SD_IE from './sd.ie'
import SD_UK from './sd.uk'

import ASDA_UK from './asda.uk'

const META_DATA = {
  zava: {
    ...ZAVA_DE,
    ...ZAVA_UK,
    ...ZAVA_FR,
    ...ZAVA_IE,
    ...ZAVA_ES,
    ...ZAVA_IT
  },
  sd: {
    ...SD_IE,
    ...SD_UK
  },
  tosca: {
    ...ASDA_UK
  }
}

export function generateMetaData (brand, locale, canonicalUrl) {
  const data = { ...META_DATA[brand][locale] }

  if (canonicalUrl) {
    data.link = [...(data.link || []), {
      rel: 'canonical',
      href: canonicalUrl
    }]
  }

  return data
}
